import Vue from 'vue';
/**
 * @desc 注册'v-animate'  当元素出现在p屏幕可视范围正中间时添加类名触发动效样式
 */
Vue.directive('animate', {
  inserted: function(el, binding) {
    // 聚焦元素
    binding.addClass = () => {
      const { top } = el.getBoundingClientRect();
      const h = document.documentElement.clientHeight || document.body.clientHeight;
      if (top < h / 2) {
        const classNameList = el.className.split(' ');
        if (classNameList.indexOf(binding.value) == -1) {
          // 初次还未绑定过，则新增类名(注意：下面单引号中间是一个空格！！！)
          el.className = binding.value + ' ' + el.className;
        }
        if (binding.addClass) {
          window.removeEventListener('scroll', binding.addClass);
        }
      }
    };
    window.addEventListener('scroll', binding.addClass, true);
    binding.addClass();
  },
  unbind: function(el, binding) {
    if (binding.addClass) {
      window.removeEventListener('scroll', binding.addClass);
    }
  }
});
